// @flow
import * as React from 'react'
import SVGResponsive from '../SVGResponsive'

export default class FacebookIcon extends React.Component<*> {
  render = () => {
    return (
      <SVGResponsive title="Facebook" height={100} width={100}>
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          transform="translate(-71.000000, -787.000000)"
        >
          <g transform="translate(71.000000, 787.000000)" fill="#4967AD">
            <path d="M100,50 C100,77.6138889 77.6138889,100 50,100 C22.3861111,100 0,77.6138889 0,50 C0,22.3861111 22.3861111,0 50,0 C77.6138889,0 100,22.3861111 100,50 L100,50 Z M53.0083333,50 L58.4,50 L59.1166667,43.2638889 L53.0083333,43.2638889 L53.0166667,39.8944444 C53.0166667,38.1388889 53.1833333,37.1972222 55.7083333,37.1972222 L59.0777778,37.1972222 L59.0777778,30.4611111 L53.6833333,30.4611111 C47.2055556,30.4611111 44.9222222,33.7305556 44.9222222,39.2222222 L44.9222222,43.2638889 L40.8833333,43.2638889 L40.8833333,50 L44.9222222,50 L44.9222222,69.5388889 L53.0083333,69.5388889 L53.0083333,50 L53.0083333,50 Z" />
          </g>
        </g>
      </SVGResponsive>
    )
  }
}
